<template>
  <aside
    v-if="$store.state.user && activeModule"
    class="menu"
    :class="{ menuexpand: expanded }"
  >
    <div class="menu-list-container">
      <!-- top half menu components -->
      <ul class="menu-list">
        <li class="nav-control">
          <a @click="toggleSidebar" @keypress="toggleSidebar" tabindex="0" role="button">
            <font-awesome-icon v-if="!expanded" :icon="['fal', 'angle-right']" title="Expand"/>
            <font-awesome-icon v-else :icon="['fal', 'angle-left']" title="Collapse"/>
          </a>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link icon-lg"
            :to="{ path: homePath }"
            @keydown.enter.native="handleKeyboardNavigation">
            <font-awesome-icon :icon="['fal', 'home']" title="Home"/>
            <span class="link-description" v-if="expanded">
              Home
            </span>
          </router-link>
        </li>
        <li
          class="nav-item"
          v-if="isDirectMatch && (hasModule('DRMCH:MATCH:OPTIONS:VIEW'))"
        >
          <router-link
            class="nav-link icon-lg"
            :to="{ path: `/directMatch/matchOptions${defaultDmMatchOptionsRoute}` }"
            @keydown.enter.native="handleKeyboardNavigation"
          >
            <font-awesome-icon :icon="['fal', 'check-circle']"/>
            <span class="link-description" v-if="expanded">
              Match Options
            </span>
          </router-link>
        </li>
        <li
          v-if="isDirectMatch && hasModule('DRMCH:CEP:MGR:VIEW')"
          class="nav-item">
          <router-link class="nav-link icon-lg" :to="{ path: '/directMatch/cep' }"
            @keydown.enter.native="handleKeyboardNavigation"
          >
            <font-awesome-icon :icon="['fal', 'abacus']"/>
            <span class="link-description" v-if="expanded">
              Cep Manager
            </span>
          </router-link>
        </li>
        <li
          v-if="isDirectMatch &&  hasModule('DRMCH:SRCH:OPTIONS:VIEW')"
          class="nav-item"
        >
          <router-link class="nav-link icon-lg" :to="{name: 'directMatchSearch'}"
            @keydown.enter.native="handleKeyboardNavigation"
          >
            <font-awesome-icon :icon="['fal', 'search-plus']"/>
            <span class="link-description" v-if="expanded">
              Student Search
            </span>
          </router-link>
        </li>
        <li
          v-if="isPersonId && hasModule('PRSID:MATCH:OPTIONS:VIEW')"
          class="nav-item"
        >
          <router-link
            class="nav-link icon-lg"
            :to="{ path: '/personId/matchOptions' }"
            @keydown.enter.native="handleKeyboardNavigation"
          >
            <font-awesome-icon :icon="['fal', 'check-circle']" title="Match Options"/>
            <span class="link-description" v-if="expanded">
              Match Options
            </span>
          </router-link>
        </li>
        <li
          v-if="(isLocationId && hasModule('LOCID:REP:VIEW'))
            || (isDirectMatch && hasModule('DRMCH:REP:VIEW'))
            || (isPersonId && hasModule('PRSID:REP:VIEW'))"
          class="nav-item">
          <router-link class="nav-link icon-lg" :to="`/${activeModule.name}/reports`" @keydown.enter.native="handleKeyboardNavigation">
            <font-awesome-icon :icon="['fal', 'file-chart-line']" title="Reports"/>
            <span class="link-description" v-if="expanded">
              Reports
            </span>
          </router-link>
        </li>
        <li v-if="isPersonId && hasModule('PRSID:SRCH:OPTIONS:VIEW')" class="nav-item">
          <router-link class="nav-link icon-lg"
            :to="{ name: `${defaultPidSearchTab}` }"
            :class="{ 'is-active': this.$route.path.includes('search') }"
            @keydown.enter.native="handleKeyboardNavigation"
          >
            <font-awesome-icon :icon="['fal', 'search-plus']" title="Search"/>
            <span class="link-description" v-if="$store.state.sidebarOpen === true">
              Search
            </span>
          </router-link>
        </li>
        <li v-if="isPersonId && hasModule('PRSID:MATCH:OPTIONS:PRSN:ADD')" class="nav-item">
          <router-link
            class="nav-link icon-lg"
            :to="{ path: '/personId/addPerson' }"
            @keydown.enter.native="handleKeyboardNavigation"
          >
            <font-awesome-icon :icon="['fal', 'plus']" title="Add Person"/>
            <span class="link-description" v-if="expanded">
              Add Person
            </span>
          </router-link>
        </li>
        <li
          class="nav-item"
          v-if="isLocationId
            && hasModule('LOCID:SRCH:OPTIONS:VIEW')"
        >
          <router-link class="nav-link icon-lg" :to="{ path: '/locationId/search' }"
            @keydown.enter.native="handleKeyboardNavigation"
          >
            <font-awesome-icon :icon="['fal', 'search-plus']"/>
            <span class="link-description" v-if="expanded">
              Search
            </span>
          </router-link>
        </li>
        <li
          v-if="isLocationId &&  hasModule('LOCID:LOC:ADD')"
          class="nav-item"
        >
          <router-link class="nav-link icon-lg" :to="{name: 'locationCreate'}"
            @keydown.enter.native="handleKeyboardNavigation"
          >
            <font-awesome-icon :icon="['fal', 'plus']"/>
            <span class="link-description" v-if="expanded">
              Location Create
            </span>
          </router-link>
        </li>
      </ul>
      <!-- bottom half menu components -->
      <ul class="menu-list">
        <li class="nav-item" v-if="isPersonId && hasModule('PRSID:IDENT:IDMANAGER:VIEW')">
          <router-link class="nav-link icon-lg"
            :to="`/${activeModule.name}/identifierManager`"
            title="ID Manager"
            @keydown.enter.native="handleKeyboardNavigation"
          >
            <font-awesome-icon :icon="['fal', 'users-viewfinder']" />
            <span class="link-description" v-if="expanded">
              ID Manager
            </span>
          </router-link>
        </li>
        <li class="nav-item" v-if="hasModule('SYS:SYS:RULEMGR:VIEW')">
          <router-link class="nav-link icon-lg"
            :to="{ name: defaultRuleTab }"
            :class="{ 'is-active': this.$route.path.includes('ruleManager') }"
            @keydown.enter.native="handleKeyboardNavigation"
          >
            <font-awesome-icon :icon="['fal', 'ruler-combined']" title="Rule Manager"/>
            <span class="link-description" v-if="expanded">
              Rule Manager
            </span>
          </router-link>
        </li>
        <li class="nav-item" v-if="hasModule('SYS:SYS:CONFIGMGR:VIEW')">
          <router-link class="nav-link icon-lg"
            :to="`/${activeModule.name}/configurationManager`"
            @keydown.enter.native="handleKeyboardNavigation"
          >
            <font-awesome-icon :icon="['fal', 'tools']" title="Configuration Manager"/>
            <span class="link-description" v-if="expanded">
              Configuration Manager
            </span>
          </router-link>
        </li>
        <li class="nav-item" v-if="hasModule('SYS:SEC:MGR:VIEW')">
          <router-link class="nav-link icon-lg"
            :to="`/${activeModule.name}/securityManager`"
            @keydown.enter.native="handleKeyboardNavigation"
          >
            <font-awesome-icon :icon="['fal', 'users-cog']" title="Security Manager"/>
            <span class="link-description" v-if="expanded">
              Security Manager
            </span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link icon-lg" to="/logout">
            <font-awesome-icon
                :icon="['fal', 'sign-out']"
                class="fa-flip-horizontal"
                title="Sign Out" />
            <span class="link-description" v-if="expanded">
              Sign Out
            </span>
          </router-link>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAbacus,
  faAngleLeft,
  faAngleRight,
  faCheckCircle,
  faFileChartLine,
  faFileCheck,
  faDownload,
  faHome,
  faMapMarkerAlt,
  faRulerCombined,
  faPlus,
  faSearchPlus,
  faSignOut,
  faSitemap,
  faTools,
  faUpload,
  faUsersCog,
  faUser,
  faUsersViewfinder,
} from '@fortawesome/pro-light-svg-icons';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faAbacus,
  faAngleLeft,
  faAngleRight,
  faCheckCircle,
  faFileChartLine,
  faFileCheck,
  faDownload,
  faHome,
  faMapMarkerAlt,
  faRulerCombined,
  faPlus,
  faSearchPlus,
  faSignOut,
  faSitemap,
  faTools,
  faUpload,
  faUsersCog,
  faUser,
  faUsersViewfinder,
);

export default {
  mixins: [
    PermissionManager,
  ],
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
      allModules: 'appModules/getAllModules',
    }),
    expanded() {
      return this.$store.state.sidebarOpen;
    },
    homePath() {
      if (this.isLocationId) {
        return '/locationId/location-groups';
      }
      return `/${this.activeModule.landing}/dashboard`;
    },
    isDirectMatch() {
      return this.activeModule.name === 'directMatch';
    },
    isLocationId() {
      return this.activeModule.name === 'locationID';
    },
    isPersonId() {
      return this.activeModule.name === 'personId';
    },
    defaultDmMatchOptionsRoute() {
      if (this.hasModule('DRMCH:MATCH:OPTIONS:PERSONTAB:VIEW')) {
        return '/person';
      }
      if (this.hasModule('DRMCH:MATCH:OPTIONS:ADDRESS:VIEW')) {
        return '/address';
      }
      return '';
    },
    defaultPersonIdhOptionsRoute() {
      if (this.hasModule('PRSID:MATCH:OPTIONS:UPLOADFILE')) {
        return '/upload';
      }
      return '';
    },
    defaultRuleTab() {
      if ((this.activeModule && this.activeModule.name) === 'personId') {
        return 'PidRuleManagerPersonId';
      }
      if ((this.activeModule && this.activeModule.name) === 'directMatch') {
        return 'DmRuleManagerPersonId';
      }
      if ((this.activeModule && this.activeModule.name) === 'locationID') {
        return 'PidRuleManagerPersonId';
      }
      return '/notAuthorized';
    },
    defaultPidSearchTab() {
      if (this.hasModule('PRSID:SRCH:OPTIONS:PRSN:SRCH')) {
        return 'PidSearchPerson';
      }
      if (this.hasModule('PRSID:SRCH:OPTIONS:LOC:SRCH')) {
        return 'PidSearchLocation';
      }
      if (this.hasModule('PRSID:SRCH:OPTIONS:BATCH:SRCH')) {
        return 'PidSearchFile';
      }
      if (this.hasModule('PRSID:SRCH:OPTIONS:ADV:SRCH')) {
        return 'PidSearchAdvanced';
      }
      return 'pidNotAuthorized';
    },
  },
  methods: {
    ...mapActions([
      'toggleSidebar',
    ]),
    handleKeyboardNavigation() {
      this.$emit('keyboard-navigate');
    },
  },
};
</script>

<style lang="sass" scoped>
  .menu
    background: rgb(77, 77, 77)
  .menu-label
    height: 24px
    color: #fff
  .menu-list
    color: #fff
    display: flex
    flex-direction: column
  .nav-control
    text-align: right
    line-height: .6rem
    background: rgb(77, 77, 77)
    &:hover
     background: rgba(77, 77, 77, 0) !important
  .nav-item
    text-transform: uppercase
    float: left
    height: 38px
    width: 100%
    margin: .25rem 0 .25rem
    display: inline-block
    a
      text-decoration: none
      border-left: 3px solid transparent
      &:hover
        border-left: 3px solid #fff
      &.is-active
        border-left: 3px solid #fff
  .nav-link
    display: flex
    align-items: center
    float: left
    text-align: left
    width: 100%
    height: 100%
  .icon-lg svg
    min-height: 22px
    min-width: 22px
  .link-description
    margin-left: 1rem
    font-size: 0.6rem
    font-weight: 500
  .version
    font-size: .55rem
  @media screen and (min-width: 1024px), print
    .menu-list-container
      width: 54px
      height: calc(100vh - (2.9rem + 80px))
      top: calc(2.9rem + 80px)
      background: rgb(77, 77, 77)
      position: fixed
      align-self: start
      overflow-y: auto
      display: flex
      flex-direction: column
      justify-content: space-between
      ul
        margin: 25px 0
      ul:first-child
        margin: 0
      ul:last-child
        justify-content: flex-end
        margin-bottom: 0
    .menuexpand .menu-list-container
      width: 145px
</style>
